
import {
  defineComponent,
  computed,
  ref, onMounted, onBeforeUnmount, nextTick,
} from 'vue';

export default defineComponent({
  props: {
    type: {
      type: String,
      required: false,
      default: () => 'ul',
    },
    icon: {
      type: String,
      required: false,
      default: () => 'fas fa-check',
    },
    iconColor: {
      type: String,
      required: false,
      default: () => 'primary',
    },
    fontSize: {
      type: String,
      required: false,
      default: () => 'regular',
    },
    items: {
      type: [String, Array],
      required: false,
      default: () => btoa(JSON.stringify([''])),
    },
    gridSize: {
      type: String,
      required: false,
      default: () => '1',
    },
  },

  setup(props) {
    const tag = computed(() => (props.type === 'icon' ? 'ul' : props.type));
    const list = ref<HTMLElement>();
    const listItems = computed<string[]>(() => (Array.isArray(props.items) ? props.items : JSON.parse(atob(props.items))).filter((item: string | null) => `${item || ''}`.trim() !== ''));
    const listItemsEven = computed<string[]>(() => (listItems.value.filter((item: string, index: number) => !(index % 2))));
    const listItemsOdd = computed<string[]>(() => (listItems.value.filter((item: string, index: number) => index % 2)));
    const isAutomatedGrid = props.gridSize === '2';
    const showAutomatedGrid = ref(false);
    const checkForAutomatedGrid = ref(false);
    const listElements = ref([]);

    const classes = computed(() => {
      const listClasses = [
        'io-list',
      ];

      if (props.type === 'icon') {
        listClasses.push('fa-ul');
      }

      listClasses.push(`fs-${props.fontSize}`);

      return listClasses;
    });

    const checkIfIsAutomatedGrid = () => {
      checkForAutomatedGrid.value = true;

      nextTick(() => {
        let isAutomated = true;

        if (list.value) {
          const maxElementWidth = parseInt(`${list.value?.offsetWidth || '2'}`, 10) / 2;
          const listPadding = parseInt(window.getComputedStyle(list.value, null).getPropertyValue('padding-left') || '0', 10);

          listElements.value.forEach((element: HTMLElement) => {
            if ((element.offsetWidth + listPadding) > maxElementWidth) {
              isAutomated = false;
            }
          });
        } else {
          isAutomated = false;
        }

        nextTick(() => {
          checkForAutomatedGrid.value = false;

          nextTick(() => {
            showAutomatedGrid.value = isAutomated;
          });
        });
      });
    };

    onMounted(() => {
      if (isAutomatedGrid) {
        window.addEventListener('resize', checkIfIsAutomatedGrid);
        window.addEventListener('load', checkIfIsAutomatedGrid);
        checkIfIsAutomatedGrid();
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', checkIfIsAutomatedGrid);
      window.removeEventListener('load', checkIfIsAutomatedGrid);
    });

    return {
      tag,
      list,
      classes,
      listItems,
      isAutomatedGrid,
      showAutomatedGrid,
      checkForAutomatedGrid,
      listElements,
      listItemsOdd,
      listItemsEven,
    };
  },
});
